import { render, staticRenderFns } from "./CAvailableUptimeUpdateModal.vue?vue&type=template&id=5327a45a&"
import script from "./CAvailableUptimeUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./CAvailableUptimeUpdateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports